import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsForYouRoute } from '@jira/router-routes__assets-app-routes/src/assetsForYouRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { assetsForYouEntryPoint } from '@jira/assets-app__for-you-page/src/assetsForYouEntryPoint.entrypoint.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const assetsForYouPageEntryPoint = createChromelessEntryPoint({
	main: assetsForYouEntryPoint,
});

export const assetsForYouRouteEntry: Route = createEntry(assetsForYouRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	entryPoint: () => (fg('assets_for_you') ? assetsForYouPageEntryPoint : undefined),
	pageId: () => 'spa-apps/assets/for-you-page',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.interact-with-for-you-page',
	ufoName: 'assets-app-for-you-page',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
